import {IEnumListEntry} from "../definitions";
export const SPELL_TYPES = {
    ACCELERATION: 1,
    FIREFIGHTING: 2,
    SPAWN: 3,
    KILL_NUT: 4,
    SPAWN_TREE: 5,
    SPAWN_MUSHROOM: 6,
    SPAWN_METAL: 7,
    SPAWN_GRASS: 8,
    SPAWN_STONE: 9,
    SPAWN_CRYSTAL: 10,
    DYNAMITE: 14
};


export const SPELL_TYPES_LIST:IEnumListEntry[] = [
    { id: SPELL_TYPES.ACCELERATION, label: "ACCELERATION" },
    { id: SPELL_TYPES.FIREFIGHTING, label: "FIREFIGHTING" },
    { id: SPELL_TYPES.SPAWN, label: "SPAWN" },
    { id: SPELL_TYPES.KILL_NUT, label: "KILL_NUT" },
    { id: SPELL_TYPES.SPAWN_TREE, label: "SPAWN_TREE" },
    { id: SPELL_TYPES.SPAWN_MUSHROOM, label: "SPAWN_MUSHROOM" },
    { id: SPELL_TYPES.SPAWN_METAL, label: "SPAWN_METAL" },
    { id: SPELL_TYPES.SPAWN_GRASS, label: "SPAWN_GRASS" },
    { id: SPELL_TYPES.SPAWN_STONE, label: "SPAWN_STONE" },
    { id: SPELL_TYPES.SPAWN_CRYSTAL, label: "SPAWN_CRYSTAL" },
    { id: SPELL_TYPES.DYNAMITE, label: "DYNAMITE" }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-spells.ts